export const environment: Environment = {
  production: false,
  tenants: [
    {
      name: 'sstrn',
      url: 'espacebeneficiaire-sstrn.ressif-dev.com',
      bffUrl: 'https://bffservice-sstrn.ressif-dev.com',
      allowTodoList : true,
      politiqueConfidentialite: `
    <header>
      <h1>Politique de confidentialité</h1>
      <div class="meta">Dernière mise à jour : <strong>09 septembre 2025</strong></div>
    </header>

    <article>
      <section id="editeur">
        <h2>1. Éditeur de l'application</h2>
        <p>L'application <strong>Orca – Espace bénéficiaire</strong> est éditée par le <strong>Service Social du Travail
            de la Région Nord (SSTRN)</strong>.</p>
        <p>Le SSTRN, association régie par la loi 1901, dont le siège est situé au
          40 rue Eugène Jacquet, 59700 Marcq‑en‑Barœul, est responsable du traitement des données
          personnelles collectées via l'application Orca – Espace bénéficiaire.
        </p>
      </section>

      <section id="donnees">
        <h2>2. Données collectées</h2>
        <p>L'application peut collecter les catégories de données suivantes :</p>
        <ul>
          <li><strong>Données personnelles :</strong> nom, prénom, adresse e‑mail, numéro de téléphone, identifiants de
            connexion.</li>
          <li><strong>Données sensibles :</strong> documents relatifs à la santé, informations médicales ou sociales
            nécessaires à la prise en charge.</li>
          <li><strong>Données d'utilisation :</strong> statistiques d'usage, rapports de crash, informations techniques
            (via Firebase Crashlytics).</li>
        </ul>
      </section>

      <section id="collecte">
        <h2>3. Méthodes de collecte</h2>
        <p>Outre les informations que vous renseignez directement (création de compte, prise de rendez‑vous,
          téléchargement de documents), certaines données sont collectées automatiquement lors de l'utilisation de
          l'application.</p>
        <p>Ces données techniques (par exemple : identifiant de l'appareil, rapports d'erreurs, statistiques
          d'utilisation) sont générées par l'application ou par nos prestataires techniques afin d'assurer son bon
          fonctionnement, d'améliorer la qualité du service et de permettre l'envoi de notifications.</p>
      </section>

      <section id="finalites">
        <h2>4. Finalités de la collecte</h2>
        <p>Les données sont collectées et traitées afin de :</p>
        <ul>
          <li>Offrir un service personnalisé et adapté aux bénéficiaires.</li>
          <li>Permettre la prise de rendez‑vous et l'échange d'informations avec les praticiens.</li>
          <li>Assurer le suivi social, médical et psychologique par les équipes du SSTRN.</li>
          <li>Envoyer des notifications et des rappels utiles.</li>
          <li>Améliorer la qualité et la fiabilité de l'application.</li>
        </ul>
      </section>

      <section id="partage">
        <h2>5. Partage des données</h2>
        <p>Les données personnelles collectées via l'application sont destinées exclusivement aux services internes du
          SSTRN et aux professionnels dûment habilités, dans la limite de leurs missions et de leurs attributions.</p>
        <p>Lorsque cela est strictement nécessaire, les données peuvent également être communiquées :</p>
        <ul>
          <li>à des prestataires techniques et sous‑traitants intervenant pour le compte du SSTRN (hébergement,
            maintenance, envoi de notifications, gestion des rendez‑vous, etc.), dans le respect des exigences du RGPD et
            sur la base de contrats conformes ;</li>
          <li>aux autorités administratives, judiciaires ou organismes publics, lorsque la loi l'exige ou l'autorise.</li>
        </ul>
        <p><strong>En aucun cas</strong> les données ne sont cédées à des tiers à des fins commerciales ou publicitaires.
        </p>
      </section>

      <section id="hebergement">
        <h2>6. Hébergement et sécurité</h2>
        <p>Les données sont hébergées sur des serveurs sécurisés <strong>Microsoft Azure HDS (Hébergement de Données de
            Santé)</strong>.</p>
        <p>Le SSTRN ne transfère pas de données en dehors de l'Union européenne.</p>
      </section>

      <section id="conservation">
        <h2>7. Durée de conservation</h2>
        <ul>
          <li>Les données sont supprimées à la demande de l'utilisateur.</li>
          <li>À défaut, elles sont conservées <strong>3 ans</strong> après la dernière connexion.</li>
          <li>Les comptes utilisateurs restent actifs pendant <strong>3 ans</strong>.</li>
        </ul>
      </section>

      <section id="droits">
        <h2>8. Droits des utilisateurs</h2>
        <p>Conformément au RGPD, chaque utilisateur dispose d'un droit d'accès, de rectification, de suppression et de
          portabilité de ses données.</p>
        <p>Vous pouvez exercer ces droits auprès du Délégué à la protection des données :</p>
        <div class="contact">
          <address>
            <strong>SSTRN – À l'attention du DPO</strong><br>
            40 rue Eugène Jacquet<br>
            59700 MARCQ‑EN‑BAROEUL<br>
            <br>
            <a href="mailto:dpo@sstrn.com">dpo&#64;sstrn.com</a>
          </address>
        </div>
        <p class="note">Nous nous efforcerons de donner suite à votre demande dans un délai raisonnable et, en tout état
          de cause, dans les délais fixés par la loi.</p>
        <p>En cas de réponse que vous estimeriez insatisfaisante, vous pouvez introduire une réclamation auprès de la
          CNIL, autorité de contrôle compétente en France.</p>
        <p class="note">CNIL — 3 Place de Fontenoy – TSA 80715 – 75334 PARIS CEDEX 07</p>
      </section>

      <section id="perimetre">
        <h2>9. Périmètre de la politique</h2>
        <p>Cette politique de confidentialité concerne uniquement l'application <strong>Orca – Espace
            bénéficiaire</strong>.</p>
        <p>Pour en savoir plus sur la façon dont le SSTRN traite vos données dans le cadre de ses autres activités
          (accompagnement social, suivi médical, prévention en entreprise…), vous pouvez consulter la Politique générale
          de protection des données disponible sur notre site internet : <a href="https://www.sstrn.com" target="_blank"
            rel="noopener">www.sstrn.com</a>.</p>
      </section>

    </article>

    <footer>
      <p class="note">Document généré pour diffusion. Si vous souhaitez une version imprimable (PDF) ou des adaptations
        (version courte, mentions légales supplémentaires), contactez <a href="mailto:dpo@sstrn.com">dpo&#64;sstrn.com</a>.</p>
    </footer>
  `
    },
    {
      name: 'cite_entreprises',
      url: 'espacebeneficiaire-cite.ressif-dev.com',
      bffUrl: 'https://bffservice-cite.ressif-dev.com',
      allowTodoList : false,
      politiqueConfidentialite: `
    <header>
      <h1>Politique de confidentialité</h1>
      <div class="meta">Dernière mise à jour : <strong>09 septembre 2025</strong></div>
    </header>

    <article>
      <section id="editeur">
        <h2>1. Éditeur de l'application</h2>
        <p>L'application <strong>Orca – Espace bénéficiaire</strong> est éditée par le <strong>Service Social du Travail
            de la Région Nord (SSTRN)</strong>.</p>
        <p>Le SSTRN, association régie par la loi 1901, dont le siège est situé au
          40 rue Eugène Jacquet, 59700 Marcq‑en‑Barœul, est responsable du traitement des données
          personnelles collectées via l'application Orca – Espace bénéficiaire.
        </p>
      </section>

      <section id="donnees">
        <h2>2. Données collectées</h2>
        <p>L'application peut collecter les catégories de données suivantes :</p>
        <ul>
          <li><strong>Données personnelles :</strong> nom, prénom, adresse e‑mail, numéro de téléphone, identifiants de
            connexion.</li>
          <li><strong>Données sensibles :</strong> documents relatifs à la santé, informations médicales ou sociales
            nécessaires à la prise en charge.</li>
          <li><strong>Données d'utilisation :</strong> statistiques d'usage, rapports de crash, informations techniques
            (via Firebase Crashlytics).</li>
        </ul>
      </section>

      <section id="collecte">
        <h2>3. Méthodes de collecte</h2>
        <p>Outre les informations que vous renseignez directement (création de compte, prise de rendez‑vous,
          téléchargement de documents), certaines données sont collectées automatiquement lors de l'utilisation de
          l'application.</p>
        <p>Ces données techniques (par exemple : identifiant de l'appareil, rapports d'erreurs, statistiques
          d'utilisation) sont générées par l'application ou par nos prestataires techniques afin d'assurer son bon
          fonctionnement, d'améliorer la qualité du service et de permettre l'envoi de notifications.</p>
      </section>

      <section id="finalites">
        <h2>4. Finalités de la collecte</h2>
        <p>Les données sont collectées et traitées afin de :</p>
        <ul>
          <li>Offrir un service personnalisé et adapté aux bénéficiaires.</li>
          <li>Permettre la prise de rendez‑vous et l'échange d'informations avec les praticiens.</li>
          <li>Assurer le suivi social, médical et psychologique par les équipes du SSTRN.</li>
          <li>Envoyer des notifications et des rappels utiles.</li>
          <li>Améliorer la qualité et la fiabilité de l'application.</li>
        </ul>
      </section>

      <section id="partage">
        <h2>5. Partage des données</h2>
        <p>Les données personnelles collectées via l'application sont destinées exclusivement aux services internes du
          SSTRN et aux professionnels dûment habilités, dans la limite de leurs missions et de leurs attributions.</p>
        <p>Lorsque cela est strictement nécessaire, les données peuvent également être communiquées :</p>
        <ul>
          <li>à des prestataires techniques et sous‑traitants intervenant pour le compte du SSTRN (hébergement,
            maintenance, envoi de notifications, gestion des rendez‑vous, etc.), dans le respect des exigences du RGPD et
            sur la base de contrats conformes ;</li>
          <li>aux autorités administratives, judiciaires ou organismes publics, lorsque la loi l'exige ou l'autorise.</li>
        </ul>
        <p><strong>En aucun cas</strong> les données ne sont cédées à des tiers à des fins commerciales ou publicitaires.
        </p>
      </section>

      <section id="hebergement">
        <h2>6. Hébergement et sécurité</h2>
        <p>Les données sont hébergées sur des serveurs sécurisés <strong>Microsoft Azure HDS (Hébergement de Données de
            Santé)</strong>.</p>
        <p>Le SSTRN ne transfère pas de données en dehors de l'Union européenne.</p>
      </section>

      <section id="conservation">
        <h2>7. Durée de conservation</h2>
        <ul>
          <li>Les données sont supprimées à la demande de l'utilisateur.</li>
          <li>À défaut, elles sont conservées <strong>3 ans</strong> après la dernière action d'accompagnement.</li>
          <li>Les comptes utilisateurs restent actifs pendant <strong>10 ans</strong>.</li>
        </ul>
      </section>

      <section id="droits">
        <h2>8. Droits des utilisateurs</h2>
        <p>Conformément au RGPD, chaque utilisateur dispose d'un droit d'accès, de rectification, de suppression et de
          portabilité de ses données.</p>
        <p>Vous pouvez exercer ces droits auprès du Délégué à la protection des données :</p>
        <div class="contact">
          <address>
            <strong>SSTRN – À l'attention du DPO</strong><br>
            40 rue Eugène Jacquet<br>
            59700 MARCQ‑EN‑BAROEUL<br>
            <br>
            <a href="mailto:dpo@sstrn.com">dpo&#64;sstrn.com</a>
          </address>
        </div>
        <p class="note">Nous nous efforcerons de donner suite à votre demande dans un délai raisonnable et, en tout état
          de cause, dans les délais fixés par la loi.</p>
        <p>En cas de réponse que vous estimeriez insatisfaisante, vous pouvez introduire une réclamation auprès de la
          CNIL, autorité de contrôle compétente en France.</p>
        <p class="note">CNIL — 3 Place de Fontenoy – TSA 80715 – 75334 PARIS CEDEX 07</p>
      </section>

      <section id="perimetre">
        <h2>9. Périmètre de la politique</h2>
        <p>Cette politique de confidentialité concerne uniquement l'application <strong>Orca – Espace
            bénéficiaire</strong>.</p>
        <p>Pour en savoir plus sur la façon dont le SSTRN traite vos données dans le cadre de ses autres activités
          (accompagnement social, suivi médical, prévention en entreprise…), vous pouvez consulter la Politique générale
          de protection des données disponible sur notre site internet : <a href="https://www.sstrn.com" target="_blank"
            rel="noopener">www.sstrn.com</a>.</p>
      </section>

    </article>

    <footer>
      <p class="note">Document généré pour diffusion. Si vous souhaitez une version imprimable (PDF) ou des adaptations
        (version courte, mentions légales supplémentaires), contactez <a href="mailto:dpo@sstrn.com">dpo&#64;sstrn.com</a>.</p>
    </footer>
  `
    }
  ],
  hoursBeforeDeleteRdv: 24,
  hideTailwindBreakpoints: true,
  hideTanstackDevtool: true,
  appStateApiUrl: 'https://orcaappstate-sstrn.ressif-dev.com',
  appVersion: '17.0.0',
};
